import { ReactComponent as GithubIcon } from 'assets/icons/logos/github24.svg'
import { ReactComponent as NoneIcon } from 'assets/icons/common/link.svg'

export const renderFallbackThumbnail = (provider: string) => {
  switch (provider) {
    case 'github.com':
      return <GithubIcon />

    default:
      return <NoneIcon />
  }
}
